// removed by extract-text-webpack-plugin
module.exports = {"featureLandingPageHeader":"nYKSQ5ZhuGyZjrG1djpxL","logo":"_3rTKFQbSohuPZ0c9mhI0dt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureLandingPageHeader/FeatureLandingPageHeader.module.scss
// module id = 760
// module chunks = 0